<page-headline
    [linkTitle]="'Historical Trends Module'"
    [module]="'historical-trends'"
    [moduleIcon]="'fa-chart-line'"
    [moduleLink]="'historical-trends'"
    [pageTitle]="'Reports'"
>
</page-headline>

<p>
    This page is a placeholder.
</p>
